<script setup lang="ts">
import {navigateToPaymentUrl} from "@/modules/Utilities";
import sendEvent from "@/composables/sendEvent";
import Button from "primevue/button";

const props = withDefaults(defineProps<{
    label?: string;
    location?: string;
    host?: string;
    tone?: 'primary' | 'secondary';
}>(), {
    label: 'Buy now',
    location: 'unknown',
    host: '',
    tone: 'primary'
});

const startCheckout = () => {
    sendEvent('begin_checkout', props.location, 'ecommerce', {
        checkout_location: props.location,
        ...(props.host ? {source_host: props.host} : {})
    });
    navigateToPaymentUrl(props.host || undefined);
};

</script>

<template>
<Button
    :class="tone === 'secondary'
        ? ['btn', 'p-button-outlined', 'btn-outline-secondary']
        : ['btn', 'p-button-primary', 'btn-primary', 'cta-primary']"
    type="button"
    @click="startCheckout"
>
    {{ label }}
</Button>
</template>
